import { Component, Input, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export const ASSETS_URL = '../../../../assets/images';

@Component({
  selector: 'app-custom-svg-icon[iconName]',
  templateUrl: './custom-svg-icon.component.html',
  styleUrls: ['./custom-svg-icon.component.scss']
})
export class CustomSVGIconComponent implements OnInit {
  // SVG icon name excluding the extension of image
  @Input() iconName!: string;

  // Height of the SVG icon
  @Input() height!: string;

  // Width of the SVG icon
  @Input() width!: string;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.matIconRegistry.addSvgIcon(
      this.iconName,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${ASSETS_URL}/${this.iconName}.svg`
      )
    );
  }

  /**
   * Returns the height and width object as per
   * given props value
   *
   * @returns {object} with width and height
   */
  getSvgIconStyle = () => {
    let stylingObj = {
      height: '',
      width: ''
    };

    if (this.height != null) {
      stylingObj.height = this.height;
    }

    if (this.width != null) {
      stylingObj.width = this.width;
    }

    return stylingObj;
  };
}
